import script from "./VersionDetailEditorModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./VersionDetailEditorModal.vue?vue&type=script&lang=ts&setup=true"

import "./VersionDetailEditorModal.vue?vue&type=style&index=0&id=88d0db72&lang=less"

const __exports__ = script;

export default __exports__